import { z } from 'zod';
import { SALES_ORDER_LINE_CONSTRAINTS } from './constraints.js';
/** The smallest qty the numeric(28,9) column stores as non-zero, so anything below it would persist as 0. */
export const MIN_STORABLE_QTY = 0.000000001;
export const MAX_LINE_QTY = 1_000_000_000;
// Upper bound stays well under the Decimal(28,9) column's overflow point.
export const salesOrderLineQuantitySchema = z
    .number()
    .positive({
    abort: true,
    error: `${SALES_ORDER_LINE_CONSTRAINTS.qty.label} must be greater than 0.`,
})
    .min(MIN_STORABLE_QTY, `${SALES_ORDER_LINE_CONSTRAINTS.qty.label} must be at least 0.000000001.`)
    .max(MAX_LINE_QTY, `${SALES_ORDER_LINE_CONSTRAINTS.qty.label} must be 1,000,000,000 or less.`);
//# sourceMappingURL=item-quantity.js.map